import { render } from "./VTooltip.vue?vue&type=template&id=2b04b612"
import script from "./VTooltip.vue?vue&type=script&lang=js"
export * from "./VTooltip.vue?vue&type=script&lang=js"

import "./VTooltip.vue?vue&type=style&index=0&id=2b04b612&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__